import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FileDownloaderService {
  downloadUrl(url: string, fileName?: string) {
    let link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
  }
}
